@use '../../styling/colors.scss' as *;

.LockIndicator {
  .icon-locked path {
    fill: $color-primary-green;
  }

  .icon-unlocked path {
    fill: $theme-filter-icon-color;
  }
}
